/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Safari/Firefox fix: delegated load events on document are unreliable for
  // <picture> elements and loading="lazy" images. Attach individual listeners
  // so is-loading (opacity: 0) is always cleared when an image finishes.
  function clearLoadingClass(img) {
    img.classList.remove('is-loading');
    var parent = img.parentNode;
    if (parent) {
      parent.classList.remove('is-loading');
      if (parent.parentNode && parent.parentNode.classList.contains('is-loading')) {
        parent.parentNode.classList.remove('is-loading');
      }
    }
  }

  function watchImage(img) {
    if (!img.classList.contains('is-loading')) return;
    // Already decoded and cached — clear immediately
    if (img.complete && img.naturalWidth > 0) {
      clearLoadingClass(img);
      return;
    }
    img.addEventListener('load',  function() { clearLoadingClass(img); }, { once: true });
    img.addEventListener('error', function() { clearLoadingClass(img); }, { once: true });
  }

  function watchAllImages(root) {
    root.querySelectorAll('img.is-loading').forEach(watchImage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { watchAllImages(document); });
  } else {
    watchAllImages(document);
  }

  // Safari/Firefox fix: slider arrow buttons call goToSlide() based on which
  // item has .is-visible, but the IntersectionObserver that sets that class
  // fires asynchronously — so early clicks find no .is-visible item and do
  // nothing. This handler falls back to scroll-position math when is-visible
  // is missing, and uses closest() so SVG child clicks are handled correctly.
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-button-prev], [data-button-next]');
    if (!btn) return;

    var gridSlider = btn.closest('grid-slider');
    if (!gridSlider) return;

    var slider = gridSlider.querySelector('[data-grid-slider]');
    if (!slider) return;

    // Only act when the theme's own is-visible tracking hasn't kicked in yet
    if (slider.querySelector('[data-grid-item].is-visible')) return;

    e.preventDefault();
    e.stopPropagation();

    var items = Array.from(slider.querySelectorAll('[data-grid-item]'));
    if (!items.length) return;

    // Find the item closest to current scroll position
    var scrollLeft = slider.scrollLeft;
    var current = items.reduce(function(best, item) {
      return Math.abs(item.offsetLeft - scrollLeft) < Math.abs(best.offsetLeft - scrollLeft) ? item : best;
    });

    var idx = items.indexOf(current);
    var target = btn.hasAttribute('data-button-prev') ? items[idx - 1] : items[idx + 1];
    if (target) {
      slider.scrollTo({ top: 0, left: target.offsetLeft, behavior: 'smooth' });
    }
  }, true);

  // Safari/Firefox fix: grid-slider's connectedCallback fires before the browser
  // has calculated layout, so clientWidth=0 and the slider destroys itself
  // immediately (0 < 0 is false). Dispatch theme:resize:width after load so
  // it retries toggleSlider() with real dimensions and inits arrows + drag.
  window.addEventListener('load', function() {
    setTimeout(function() {
      document.dispatchEvent(new CustomEvent('theme:resize:width'));
    }, 50);
  });

  // Safari/Chrome parallax fix: Rellax.js initialises before the browser has
  // settled scroll/layout, causing the image to be mis-translated on first
  // paint. Force a refresh after load so the position is recalculated correctly.
  var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  var isChrome = /chrome/i.test(navigator.userAgent) && /google inc/i.test(navigator.vendor);
  if (isSafari || isChrome) {
    window.addEventListener('load', function() {
      // Chrome needs a slightly longer wait than Safari to catch the compositor settling
      var delay = isChrome ? 200 : 100;
      setTimeout(function() {
        document.querySelectorAll('parallax-hero').forEach(function(el) {
          if (el.rellax) {
            el.rellax.refresh();
          }
        });
      }, delay);
    });
  }

  // Safari/Firefox fix: CSS grid-slider:hover is unreliable on custom elements.
  // Manually toggle .is-hovered so the arrow CSS rule fires correctly.
  function attachGridSliderHover(el) {
    if (el._hoverBound) return;
    el._hoverBound = true;
    el.addEventListener('mouseenter', function() { el.classList.add('is-hovered'); });
    el.addEventListener('mouseleave', function() { el.classList.remove('is-hovered'); });
  }

  document.querySelectorAll('grid-slider').forEach(attachGridSliderHover);

  // Catch images injected after page load (sliders, quick-add, etc.)
  new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType !== 1) return;
        if (node.tagName === 'IMG') {
          watchImage(node);
        } else {
          watchAllImages(node);
        }
        if (node.tagName === 'GRID-SLIDER') {
          attachGridSliderHover(node);
        } else {
          node.querySelectorAll('grid-slider').forEach(attachGridSliderHover);
        }
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
